import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './index.scss';
import '../../styles/menu.scss';
import '../../styles/container.scss';
import NewsHotList from '../../components/NewsHotList';
import { fetchNewsFromDoubao } from '../../utils/doubao';

// 新的资讯菜单，label为页面显示，path为路由，apiCategory为天行API分类
const newsMenus = [
  { label: '科技', path: 'keji', apiCategory: '科技' },
  { label: '娱乐', path: 'huabian', apiCategory: '娱乐' },
  { label: '体育', path: 'tiyu', apiCategory: '体育' },
  { label: '社会', path: 'social', apiCategory: '社会' },
  // { label: '头条', path: 'topnews', apiCategory: '头条' },
  { label: '国内', path: 'guonei', apiCategory: '国内' },
  { label: '国际', path: 'world', apiCategory: '国际' },
  // { label: '财经', path: 'finance', apiCategory: '财经' },
  { label: '健康', path: 'health', apiCategory: '健康' },
  { label: '旅游', path: 'travel', apiCategory: '旅游' },
  { label: '汽车', path: 'auto', apiCategory: '汽车' },
  { label: '游戏', path: 'game', apiCategory: '游戏' },
];

const CACHE_PREFIX = 'news_cache_';
const CACHE_EXPIRE = 6 * 60 * 60 * 1000; // 6小时

function getCacheKey(category) {
  return `${CACHE_PREFIX}${category}`;
}

function getCache(category) {
  const raw = localStorage.getItem(getCacheKey(category));
  if (!raw) return null;
  try {
    const { data, time } = JSON.parse(raw);
    if (Date.now() - time < CACHE_EXPIRE && Array.isArray(data) && data.length > 0) {
      return data;
    }
  } catch {}
  return null;
}

function setCache(category, data) {
  localStorage.setItem(getCacheKey(category), JSON.stringify({ data, time: Date.now() }));
}

function removeCache(category) {
  localStorage.removeItem(getCacheKey(category));
}

export default function News() {
  const navigate = useNavigate();
  const location = useLocation();
  const activePath = location.pathname.split('/')[2] || newsMenus[0].path;
  const activeMenu = newsMenus.find(m => m.path === activePath) || newsMenus[0];

  // loading与数据状态
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const abortRef = useRef();

  // 切换菜单时，先清空内容并展示骨架
  useEffect(() => {
    setList([]);
    setError(null);
    setLoading(true);
    if (abortRef.current) abortRef.current.abort();
    // 先查缓存
    const cache = getCache(activeMenu.apiCategory);
    if (cache) {
      setList(cache);
      setLoading(false);
      return;
    }
    const controller = new AbortController();
    abortRef.current = controller;
    fetch('/apis/news', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ category: activeMenu.apiCategory }),
      signal: controller.signal
    })
      .then(res => res.json())
      .then(res => {
        setList(res.data || []);
        if (res.data && Array.isArray(res.data) && res.data.length > 0) {
          setCache(activeMenu.apiCategory, res.data);
        } else {
          removeCache(activeMenu.apiCategory);
        }
      })
      .catch(e => {
        if (e.name !== 'AbortError') setError(e.message || '加载失败');
      })
      .finally(() => setLoading(false));
    return () => controller.abort();
  }, [activeMenu.apiCategory]);

  // 刷新功能
  const handleRefresh = () => {
    setList([]);
    setError(null);
    setLoading(true);
    if (abortRef.current) abortRef.current.abort();
    const controller = new AbortController();
    abortRef.current = controller;
    fetch('/apis/news', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ category: activeMenu.apiCategory }),
      signal: controller.signal
    })
      .then(res => res.json())
      .then(res => {
        setList(res.data || []);
        if (res.data && Array.isArray(res.data) && res.data.length > 0) {
          setCache(activeMenu.apiCategory, res.data);
        } else {
          removeCache(activeMenu.apiCategory);
        }
      })
      .catch(e => {
        if (e.name !== 'AbortError') setError(e.message || '加载失败');
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="page_container">
      {/* 左侧菜单栏 */}
      <div className="menu_sidebar">
        {newsMenus.map(menu => (
          <div
            key={menu.path}
            onClick={() => navigate(`/news/${menu.path}`)}
            className={`menu_item ${activePath === menu.path ? 'menu_item_active' : ''}`}
          >
            {menu.label}
          </div>
        ))}
      </div>
      {/* 右侧内容区 */}
      <div className="page_content_area">
        {loading ? (
          <div style={{padding:'48px 0',textAlign:'center',color:'#00ff99',fontSize:20,letterSpacing:2}}>
            <div className="news-skeleton" style={{margin:'0 auto 16px',width:320,height:32,background:'rgba(0,255,0,0.08)',borderRadius:8}}></div>
            <div className="news-skeleton" style={{margin:'0 auto 8px',width:480,height:20,background:'rgba(0,255,0,0.06)',borderRadius:6}}></div>
            <div className="news-skeleton" style={{margin:'0 auto 8px',width:420,height:20,background:'rgba(0,255,0,0.06)',borderRadius:6}}></div>
            <div className="news-skeleton" style={{margin:'0 auto 8px',width:380,height:20,background:'rgba(0,255,0,0.06)',borderRadius:6}}></div>
            <div style={{marginTop:24}}>AI正在为您生成最新资讯...</div>
          </div>
        ) : error ? (
          <div style={{color:'#ff4444',margin:'48px auto',textAlign:'center',fontSize:18}}>{error}</div>
        ) : (
          <NewsHotList category={activeMenu.label} list={list} onRefresh={handleRefresh} />
        )}
      </div>
    </div>
  );
} 